import React, { useContext } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ContextHome } from "../../contextHomeCloude/contextHome";
import { Adress } from "../../helpFunction/urlList";
import { toast } from "react-toastify";
import { paramsQuery } from "../../helpFunction/helpFunction";

export const MenuConectionIcon = () => {
	const context = useContext(ContextHome);

	if (!context) return null;
	const { connect, setConnect, setLoading, setReload, reload, setPath } = context;

	const connectFtp = async () => {
		const url = Adress.connect + "/" + (connect ? "disconnect" : "connect");

		try {
			setLoading(true);
			const conn = await fetch(`${url}/?${paramsQuery()}`);
			if (conn.status === 200) {
				toast.success(` ${connect ? "Rozłączono z serwerem" : "Połączono z serwerem"}`);

				setConnect(!connect);
				setReload(!reload);
				setLoading(false);
			} else {
				setConnect(false);
				setReload(!reload);
				toast.error("Brak połączenia z serwerem");
			}
		} catch (error) {
			setPath("");
			toast.error("Brak połączenia z serwerem.");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="MenuConnect" onClick={connectFtp}>
			{connect ? <FontAwesomeIcon icon="plug" beat size="xl" /> : <FontAwesomeIcon icon="plug-circle-xmark" color="white" size="xl" />}
		</div>
	);
};
